exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/modules/_wks-ext.js
// module id = 1340
// module chunks = 0